module.exports = __webpack_public_path__ + "img/founders_09.75cf1bb8.jpg";